import 'whatwg-fetch';
import _ from 'lodash';
import settings from './settings';

const getLifeRayLanguage = () => {
    if (window.Liferay) {
        return window.Liferay.ThemeDisplay.getLanguageId();
    }
    return "en_US";
}

function getQueryString(params) {
    const esc = encodeURIComponent;
    return _.keys(params)
        .map(k => `${esc(k)}=${esc(params[k])}`)
        .join('&');
}

const getUrl = (url, queryParams) => {
    if (_.keys(queryParams).length > 0) {
        url += `?${getQueryString(queryParams)}`;
    }
    return url;
};

const makeWebProtegeUrl = () => {
    return settings.webprotegeUrl;
};

const timeoutPromise = (loadTimeout) => {
    return new Promise((resolve, reject) => {
        setTimeout(
            () =>
                reject(
                    new Error({
                        message: "Connection to the Internet couldn't be established",
                    })
                ),
            loadTimeout
        );
    });
}

const ApiUtils = {

    /** Проверинь наличие авторизации  */
    checkAuthorization(params = {}, options = {}) {
        const timeout = timeoutPromise(settings.loadTimeout);
        options.method = 'get';
        let {webprotegeUrl} = settings;
        if (options.baseUrl)
            webprotegeUrl = options.baseUrl;
        //https://stat.semanticpro.org/webprotege/
        const login = new Promise((resolve, reject) => {
            fetch(webprotegeUrl + "/", options)
                .then(response => {
                    //console.log("ApiUtils.js checkAuthorization ", response);
                    if (response.status == 403){
                        reject(
                            new Error({
                                message: "Доступ запрещён",
                            })    
                        );    
                    }
                    if (response.status == 302){
                        console.log("ApiUtils.js checkAuthorization 302");
                    }
                    return ApiUtils.checkStatus(response);
                })
                .then(response => {
                    return response.text();
                })
                .then(json => {
                    resolve(json);
                })
                .catch(error => {
                    reject(error);
                });
            });
        return Promise.race([timeout, login]);    
    },

    get(url, params = {}, options = {}) {
        options.method = 'get';
        if (!options.headers) 
            options.headers = {};
        if (!options.headers["Content-type"])
            options.headers["Content-type"]='application/json';
        return this.fetch(url, params, options);
    },

    post(url, body, params = {}, options = {}) {
        options.method = 'post';
        if (!options.headers) 
            options.headers = {};
        options.body = body;
        return this.fetch(url, params, options);
    },

    fetch(url, params = {}, options = {}) {
        const timeout = timeoutPromise(settings.loadTimeout);

        let {webprotegeUrl} = settings;
        if (options.baseUrl) {
            webprotegeUrl = options.baseUrl;
        }

        const getData = new Promise((resolve, reject) => {
            fetch(webprotegeUrl + getUrl(url, params), options)
                .then(response => ApiUtils.checkStatus(response))
                .then(response => {
                    if (options.type === 'text') {
                        return response.text();
                    }
                    return response.json();
                })
                .then(json => {
                    resolve(json);
                })
                .catch(error => {
                    reject(error);
                });
        });

        return Promise.race([timeout, getData]);
    
    },


    checkStatus(response) {
        if (response.type === 'opaque') return response;
        if (response.status >= 200 && response.status < 300) {
            return response;
        }
        throw (response.error) ? response.error : `Ответ сервиса: ${response.statusText} (${response.status}).`;
    },

    convertToSelectOptions(list) {
        return _.map(list, obj => ({value: obj.id, label: obj.name}));
    },

    convertToSelectOption(option) {
        if (option == null || !option.id) return '';
        return {value: option.id, label: option.name};
    },

    /** Возвращает true, если есть объект Liferay */
    isLifeRayPresent(){
        return (window.Liferay)? true: false;
    },

    /** Возвращает двухбуквенный код языка */
    getLanguage(){
        //return "en";
        const lang = getLifeRayLanguage();
        if (lang){
            return lang.substring(0, 2);
        }else {
            return "en";
        }
    },

    /** Возвращает true, если есть пользователь залогонился */
    isSignedIn(){
        if (window.Liferay) return window.Liferay.ThemeDisplay.isSignedIn();
        //Если нужно тестить в режиме авторизации, то return true иначе return false
        return false;
    },

    getWebProtegeUrl(){
        return makeWebProtegeUrl();
    }
};

export default ApiUtils;
